import type { InitiativeOptions } from "../types";

export type LoginMode = "sso" | "manual" | null;

/**
 * Recupera un query param usato per mostrare solo una tipolgia di login
 * se loginType è "sso" allora viene mostrato solo il login SSO
 * se loginType è "manual" allora viene mostrato solo il login manuale
 */
export const getLoginType = (loginMode: LoginMode) => {
  const urlParams = new URLSearchParams(window.location.search);
  let loginType = loginMode?.toLowerCase();
  const urlLoginType = urlParams.get("loginType");
  loginType = (urlLoginType === "sso" || urlLoginType === "manual") ? urlLoginType : (loginType || "");

  const identityProvider = urlParams.get("identity_provider");
  // se presente identity_provider allora loginType è sso
  if (identityProvider) {
    loginType = "sso";
  }

  return loginType;
};

/**
 * Verifica se un URL ha un path non valido
 * @param fromUrl - L'URL da verificare
 * @returns true se il path è nella lista dei path non validi
 */
export const hasInvalidPath = (fromUrl: string | null) => {
  if (!fromUrl) {
    return false;
  }

  try {
    const url = new URL(fromUrl);
    const pathname = url.pathname;

    // Lista dei path non validi (che iniziano con questi prefissi)
    const invalidPathPrefixes = [
      "refresh",
      "logout",
      "not-found",
      "privacy",
      "terms-conditions",
      "cookie",
      "landing",
      "register",
      "agreements",
      "signup",
      "access"
    ];

    // Verifica che il path non inizi con nessuno dei prefissi non validi
    return invalidPathPrefixes.some(prefix =>
      pathname.startsWith(`/${prefix}`)
    );
  } catch (error) {
    // Se l'URL non è valido, considera il path come non valido
    return true;
  }
};

export const hasValidFromUrl = (fromUrl: string | null, initiatives: InitiativeOptions[]) => {
  if (!fromUrl || !Array.isArray(initiatives)) {
    return false;
  }

  try {
    const fromUrlObj = new URL(fromUrl);
    const fromUrlHost = fromUrlObj.host.toLowerCase();

    // Verifica che il dominio sia presente nelle iniziative
    return initiatives.some(
      (initiative) => {
        if (!initiative.urlDomain || !initiative.urlCorporateDomain) {
          return false;
        }

        const initiativeDomain = `${initiative.urlDomain}.${initiative.urlCorporateDomain}`.toLowerCase();

        // Controlla corrispondenza esatta del dominio
        if (fromUrlHost === initiativeDomain) {
          return true;
        }

        // Controlla se è un sottodominio della stessa iniziativa
        // (es. testsc.openlearning-test.digitedacademy.net dovrebbe corrispondere a openlearning-test.digitedacademy.net)
        if (fromUrlHost.endsWith(`${initiative.urlCorporateDomain.toLowerCase()}`)) {
          return true;
        }

        return false;
      }
    );
  } catch (error) {
    // Se l'URL non è valido, ritorna false
    return false;
  }
};
